import { Trans } from '@lingui/react';
import React, { useMemo, useState } from 'react';
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
} from 'reactstrap';
import { useParams } from "react-router-dom";
import dayjs from 'dayjs';

import useResourceLoader from '../../util/useResourceLoader';
import CasesApi from '../../api/CasesApi';
import Loader from '../../components/Loader';
import Notification from '../../components/Notification';
import { DATETIME_FORMAT } from '../../constants';

import "./CaseNotes.scss";
import { toDrDateTime } from "../../util/dates";

export function CaseNotes({
    id: caseId,
    readonly
}) {
    const [note, setNote] = useState('');
    const [notes, loadingNotes, error, setNotes] = useResourceLoader(
        () => CasesApi.getCaseNotes({ caseId }),
        [caseId],
        []
    );

    const [statusMap] = useResourceLoader(() => CasesApi.getWorkflowStatusMap({ caseId }), [], {});

    function noteChanged({ target: { value } }) {
        setNote(value);
    };

    async function submitNote() {
        if (note) {
            const newNote = await CasesApi.createCaseNote({ caseId, note });
            console.log(newNote);
            setNotes(notes => [newNote, ...notes]);
        }
    };

    return (<>
        {loadingNotes ? <Loader fullscreen /> : null}
        {error ? <Notification color="danger">{JSON.stringify(error)}</Notification> : null}
        <div>
            {!readonly ? (<Card className="case-note-add">
                <CardBody>
                    <textarea row="3" value={note} onChange={noteChanged} />
                </CardBody>
                <Button color="primary" onClick={submitNote}>A&ntilde;adir Nota Nueva</Button>
            </Card>) : null}
            <div className="case-notes-list">
                {!notes.length ? (
                    <Notification color="warning">No hay notas para este caso</Notification>
                ) : null}
                {notes.map(({ createdAt, note, user, associatedAction }, idx) => (
                    <Card className="case-note-container" key={idx}>
                        <CardHeader className="case-note-header">
                            <span className="case-note-date-time">{toDrDateTime(createdAt).format(DATETIME_FORMAT)}</span>
                            <span className="case-note-user">{user.firstName} {user.lastName}</span>
                            <span className="case-note-action">{statusMap[associatedAction] || associatedAction}</span>
                        </CardHeader>
                        <CardBody className="case-note-text">{note}</CardBody>
                    </Card>
                ))}
            </div>
        </div>
    </>);
}

export default CaseNotes;